/* eslint-disable default-param-last */
import {
  RESET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_APPLIED_ROLE_FILTERS,
  SET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_EXPORT_LOADING,
  SET_ROLE_FILTER,
  SET_SEARCH_TEXT_VALUE,
} from '../types';

const INITIAL_STATE = {
  dynamicSortFilter: {
    sortDirection: null,
    sortByColumn: null,
  },
  appliedRoleFilters: null,
  roleFilters: [],
  searchText: '',
  isExportLoading: false,
};

const viewControlsReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_DYNAMIC_SORT_FILTER_DETAILS:
      return {
        ...state,
        dynamicSortFilter: {
          ...state.dynamicSortFilter,
          sortDirection: action.payload.sortDirection,
          sortByColumn: action.payload.columnName,
        },
      };

    case RESET_DYNAMIC_SORT_FILTER_DETAILS:
      return {
        ...state,
        dynamicSortFilter: {
          ...state.dynamicSortFilter,
          sortDirection: null,
          sortByColumn: null,
        },
      };
    case SET_ROLE_FILTER:
      return {
        ...state,
        roleFilters: action.payload,
      };
    case SET_APPLIED_ROLE_FILTERS:
      return {
        ...state,
        appliedRoleFilters: action.payload,
      };
    case SET_SEARCH_TEXT_VALUE:
      return {
        ...state,
        searchText: action.payload,
      };
    case SET_EXPORT_LOADING:
      return {
        ...state,
        isExportLoading: !state.isExportLoading,
      };
    default:
      return state;
  }
};

export default viewControlsReducer;
